﻿export class DesignerTelemetrySession {
  constructor(designerAppService, sessionStorageMgr, isEnabled) {
    this.designerAppService = designerAppService;
    this.sessionStorageMgr = sessionStorageMgr;
    this.isEnabled = isEnabled;
    this.sessionId = null; // Will be assigned in acquireSessionAsync
    const random = this.getRandomIntInclusive(1, 1000);
    this.name = `Telemetry Session ${random}`;
  }

  getRandomIntInclusive(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1) + min); //The maximum is inclusive and the minimum is inclusive
  }

  /**
   * If a Designer telemetry session has not yet been created, creates a new Designer telemetry session.
   * The whole purpose is to monitor/report how Designer is being used.
   */
  async acquireSessionAsync(eventType, creatorName, clientDevice) {
    if (this.isEnabled) {
      //console.log(`${this.name}: getting lock access...`);
      // See extensive comments in the AsyncSemaphore class (AsyncSemaphore.js) for more on this:
      const unlock = await this.sessionStorageMgr.lockAccessAsync();
      try {
        //console.log(`${this.name}: got access!`);
        const storage = this.sessionStorageMgr.getStorage();
        this.sessionId = storage.sessionId;
        if (this.sessionId) {
          //console.log(`${this.name}: telemetry session ${this.sessionId} already present, no need to create a new session.`);
        } else {
          //console.log(`${this.name}: creating and updating telemetry session (web api)...`);
          this.sessionId = await this.designerAppService.createAndUpdateDesignerTelemetrySessionAsync(
            clientDevice.osCategory, clientDevice.opSys, clientDevice.osVersion,
            clientDevice.browserCategory, clientDevice.browser, clientDevice.userAgent, eventType, creatorName);
          if (!this.sessionId) {
            throw new Error(`The createAndUpdateDesignerTelemetrySessionAsync call returned an unassigned session id.`);
          }

          //console.log(`${this.name}: assigning telemetry session id ${this.sessionId} and saving to storage...`);
          storage.sessionId = this.sessionId;
          this.sessionStorageMgr.save();
          //console.log(`${this.name}: saved!`);
        }
      } finally {
        //console.log(`${this.name}: unlocking access...`);
        unlock();
        //console.log(`${this.name}: unlocked!`);
      }
    }
  }

  // Usage: By DesignerBtnManager.startDesignerAsync()
  async reportDesignerButtonClickedAsync() {
    if (this.isEnabled) {
      if (!this.sessionId) {
        throw new Error(`Session id was unassigned when calling the reportDesignerButtonClickedAsync method.`);
      }
      //console.log(`${this.name}: reporting Designer button clicked (web api), session id: '${this.sessionId}'`);
      await this.designerAppService.reportDesignerTelemetrySessionEventAsync(this.sessionId, 'StartBtnClicked');
    }
  }
}